import { CodedProperty, NamedProperty } from "sprint-common-web";

import { CloudAssetStatus } from "../../../assets/details/cloud-asset/CloudAssetStatus";
import { SearchAssetsSubtitleResponse } from "../../../common/api/master-api/assets/search/common/SearchAssetsSubtitleResponse";
import { LookupCloudAssetResponseItem } from "../../../common/api/master-api/assets/search/lookup-cloud-assets/GetLookupCloudAssetsResponse";
import { AssetType } from "../../../common/types/AssetType";
import { ContentReference, resolveContentTitle, resolveContentVersion } from "../../../common/types/ContentReference";
import { ContentReferenceType } from "../../../common/types/ContentReferenceType";
import { ContentSubtype } from "../../../common/types/ContentSubtype";
import { DeliveryType } from "../../../common/types/DeliveryType";
import { RecordType } from "../../../common/types/RecordType";

export interface LookupCloudAssetItem {
    id: string;
    recordType: RecordType;
    brandings: CodedProperty[];
    distributors: NamedProperty[];
    filePath?: string;
    soundtrack?: CodedProperty;
    content: ContentReference;
    contentTitle: string;
    contentType: ContentReferenceType;
    contentSubtype: ContentSubtype;
    versions: string[];
    status: CloudAssetStatus;
    subtitle?: SearchAssetsSubtitleResponse;
    versionType: NamedProperty;
    deliveryType?: DeliveryType;
    originator?: NamedProperty;
    type: AssetType;
    aspectRatio?: NamedProperty;
    trimming?: {
        startTrimmingPointTimestamp: number | undefined;
        endTrimmingPointTimestamp: number | undefined;
    };
}

export const mapToLookupCloudAssetItem = (response: LookupCloudAssetResponseItem): LookupCloudAssetItem => {
    return {
        id: response.id,
        type: response.type,
        recordType: response.recordType,
        filePath: response.filePath,
        content: response.content,
        contentTitle: resolveContentTitle(response.content),
        contentType: response.content.type,
        contentSubtype: response.content.subtype,
        versions: resolveContentVersion(response.content),
        brandings: response.brandings,
        distributors: response.distributors,
        status: response.status,
        soundtrack: response.soundtrack,
        versionType: response.versionType,
        subtitle: response.subtitle,
        deliveryType: response.deliveryType,
        aspectRatio: response.aspectRatio,
        originator: response.originator,
        trimming: response.trimming
    };
};
